import { setBlocks } from "stores/slice/bogus/dashboard/const";
import { setSurveillanceBlocks } from "stores/slice/bogus/dashboard/surveillanceConst";

const dashboardConfig = {
  // API/gluon/users/Read Dashboard Layout
  "users/dashboard.read": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboard",
  },
  // API/gluon/users/Update Dashboard Layout
  "users/dashboard.update": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: setBlocks,
    mockSelector: "dashboard",
  },
  // read top 5 , cpu, memory, poe and PoE Power Consumption
  // API/gluon/sites => /ents/{entId}/orgs/{orgId}/sites/{siteId}/stats
  // API/gluon/sites => /orgs/{orgId}/sites/{siteId}/stats (standalone)
  "/ents/:entId/orgs/:orgId/sites/:siteId/stats.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboardStats",
  },
  "/orgs/:orgId/sites/:siteId/stats.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/stats",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "dashboardStats",
  },
  "users/surveillanceDashboard.read": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "surveillanceDashboard",
  },
  "users/surveillanceDashboard.update": {
    protocol: "ws",
    resource: "/users/dashboard",
    restful: false,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: setSurveillanceBlocks,
    mockSelector: "surveillanceDashboard",
  },
};

export default dashboardConfig;
